import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\GetAvailableEventTypeDossierByIdController::__invoke
* @see app/Http/Controllers/Dossier/GetAvailableEventTypeDossierByIdController.php
* @route '/api/dossier/available-event-type/{dossier}'
*/
const GetAvailableEventTypeDossierByIdController = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetAvailableEventTypeDossierByIdController.url(args, options),
    method: 'get',
})

GetAvailableEventTypeDossierByIdController.definition = {
    methods: ["get","head"],
    url: '/api/dossier/available-event-type/{dossier}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Dossier\GetAvailableEventTypeDossierByIdController::__invoke
* @see app/Http/Controllers/Dossier/GetAvailableEventTypeDossierByIdController.php
* @route '/api/dossier/available-event-type/{dossier}'
*/
GetAvailableEventTypeDossierByIdController.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return GetAvailableEventTypeDossierByIdController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\GetAvailableEventTypeDossierByIdController::__invoke
* @see app/Http/Controllers/Dossier/GetAvailableEventTypeDossierByIdController.php
* @route '/api/dossier/available-event-type/{dossier}'
*/
GetAvailableEventTypeDossierByIdController.get = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetAvailableEventTypeDossierByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Dossier\GetAvailableEventTypeDossierByIdController::__invoke
* @see app/Http/Controllers/Dossier/GetAvailableEventTypeDossierByIdController.php
* @route '/api/dossier/available-event-type/{dossier}'
*/
GetAvailableEventTypeDossierByIdController.head = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetAvailableEventTypeDossierByIdController.url(args, options),
    method: 'head',
})

export default GetAvailableEventTypeDossierByIdController